import React, { Component } from 'react'
import * as R from 'ramda'
import { connect } from 'react-redux'
import { routerActions } from 'react-router-redux'

import EventCard from './Card'
import {List, ListItem} from 'material-ui/List'

import dataActions from 'actions/dataActions'
import { doc, dirtyRead, currentDate } from 'selectors/common'
import { propertiesLLEx } from 'selectors/properties'
import { getMonth, getTimezoneDate } from 'utils/date'


let select = dirtyRead(
	(state, props) => ({
		property: doc(state, props.propertyID)
	  , events: propertiesLLEx(state)[props.propertyID]
	  , currentDate: currentDate(state)
	})
)

export class VendorList extends Component {
	render() {
		let { props } = this
		let retired = props.property && props.property.dateTill && {
			date: (getTimezoneDate(props.property.dateTill).getDate()>9?getTimezoneDate(props.property.dateTill).getDate():('0'+getTimezoneDate(props.property.dateTill).getDate()))+' '+getMonth(getTimezoneDate(props.property.dateTill).getMonth())+' '+getTimezoneDate(props.property.dateTill).getFullYear()%100
			, type:"Retired"
		}
	    return(
			<div>
				<List
					style={{
						backgroundColor: "transparent"
						, paddingTop: "0"
					}}
				>
					{retired && <EventCard event={retired}/>}
					{props.events && props.events.history &&
						R.map(event => <EventCard event={event} currentDate={props.currentDate} retired={!!retired} />, props.events.history)
					}
				</List>
			</div>
	    )
	}
}
export default connect(select, R.mergeAll([dataActions, routerActions]))(VendorList)



// WEBPACK FOOTER //
// ./src/routes/landlord/dashboard/propertyForm/events/List.js